import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IGetTrxRedReceiptsData {
  id: number,
  trx_id: string,
  trx_id_bm: string,
  trx_type: string,
  bm_type: string,
  interval_aging: number,
  post_date: string,
  aging_date: string,
  amount: number,
  status_trx: string,
  date_close: string,
  create_at: string,
  create_by: string,
  update_at: string,
  update_by: string,
}
export interface IGetTrxRedReceiptsPayload {
  pool_id: string,
  department: string,
  code_type: string,
  area_id: string,
}
export interface IGetTrxRedReceiptsResponse {
  listSmpltrxbm: IGetTrxRedReceiptsData[];
}

export const url = "/v1/smpltrxbm";

export const getTrxRedReceipts = async (
  payload: IGetTrxRedReceiptsPayload,
): Promise<IGetTrxRedReceiptsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/transfer`,
    method: "GET",
    params: payload,
  });

  return data;
};

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface PostResponseI {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
}

export interface GetTrxRedReceiptPayloadI {
  komparasi?: string,
  search?: string,
  area_id?: string,
  pool_id?: string,
  segment?: string,
  status_trx_bon?: string,
  status_expired_bon?: string,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface GetTrxRedReceiptParamsI {
  trx_id: string,
  trx_id_bm: string,
  komparasi: string,
  warning: "Y" | "N",
  total_bon_merah: string,
  total_bon_putih_ijiran: string,
  employee_id: string,
  employee_name: string,
  department: string,
  job_title: string,
  area_id: string,
  area_desc: string,
  pool_id: string,
  segment_code: string,
  segment_desc: string,
  company_code: string,
  company_relation: string,
  status_trx: "IJIR" | "CLOSE",
  status_trx_info: "IJIR" | "BELUM ADA IJIR" | "CLOSE",
  aging_date: string,
  interval_aging: string,
  create_at: string,
  create_by: string,
  extended_bm: string,
  jumlah_ijir: string,
}

export interface IGetTrxRedReceiptResponse {
  list_trx_bm: GetTrxRedReceiptParamsI[],
  metadata: MetadataI
}

export const getTrxRedReceipt = async (
  payload: GetTrxRedReceiptPayloadI,
): Promise<IGetTrxRedReceiptResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export interface IGetTrxWhiteReceiptData {
  trx_id: string,
  trx_id_bm: string,
  employee_id: string,
  employee_name: string,
  amount: string,
  trx_date: string,
  trx_text: string,
  trx_code_detail: {
    trx_code: string,
    trx_desc: string,
    gnlldr: string,
    sap_shkzg: string,
  }
  status_trx_bmc?: string
}

interface IGetTrxWhiteReceiptResponse {
  list_bon_putih_ijir: IGetTrxWhiteReceiptData[],
  compare_amount_bon: {
    amount_bon_merah: string,
    amount_bon_putih_ijir: string,
    amount_margin: string
  },
  detail_bon_merah: {
    employee_id: string,
    employee_name: string,
    aging_date: string,
    interval_aging: string,
    interval_extend_aging: string,
    extended_status: string,
    extended_bm: string,
    bm_type: string,
    max_extension: string,
    warning: string,
  },
  detail_history_closebm: {
    trx_id?: string,
    trx_id_bm?: string,
    status_trx?: string,
    transfer_date?: string,
    close_date?: string,
    bm_type?: string,
    file_receipt?: {
      file_name: string,
      file_size: string,
      file_path: string,
      content_type: string
    }
  },
  source_bank_info: {
    source_bank_code: string,
    source_bank_account: string,
    source_bank_account_name: string,
    source_bank_account_number: string
  }
}
export const getTrxWhiteReceiptByRedReceipt = async (
  trxIdRedReceipt: string,
): Promise<IGetTrxWhiteReceiptResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${trxIdRedReceipt}/bonputih-ijiran`,
    method: "GET",
  });

  return data;
  // return {
  //   ...data,
  //   detail_history_closebm: {
  //     ...data.detail_history_closebm,
  //     file_receipt: {
  //       ...data.detail_history_closebm.file_receipt,
  //  file_name: "view-file.pdf", file_path: "SIMPLE/LAMPIRAN-BON/BMHBC2501130001",
  // file_size: "1000000 B",
  //     },
  //   },
  // };
};

interface IGetTrxWhiteReceiptDetailResponse {
  trx_id: string,
  employee_id: string,
  employee_name: string,
  area_id: string,
  area_desc: string,
  pool_id: string,
  segment_code: string,
  segment_desc: string,
  job_title: string,
  company_code: string,
  company_relation: string,
  department: string,
  detail_pengajuan: {
    trx_type: string,
    trx_type_desc: string,
    trx_date: string,
    amount: string,
    trx_text: string,
    gl_detail: {
      trx_code: string,
      trx_desc: string,
      gnlldr: string,
      sap_shkzg: string
    },
    bank_detail: {
      bank_code: string,
      bank_name: string,
      bank_account_number: string,
      bank_account_name: string
    }
  },
  lst_file: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[]
}

export const getTrxWhiteReceiptDetail = async (
  trxIdWhiteReceipt: string,
): Promise<IGetTrxWhiteReceiptDetailResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/bonputih-ijiran/${trxIdWhiteReceipt}`,
    method: "GET",
  });

  return data;
};

export const postCloseReceipt = async (
  trxIdRedReceipt: string,
): Promise<PostResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/close-bon`,
    method: "POST",
    data: {
      trx_id: trxIdRedReceipt,
      is_verifikasi: "Y",
    },
  });

  return data;
};

interface PostExtendPayload {
  trx_id: string;
  update_by: string;
  extention_job_title: string;
}

export const postExtendReceipt = async (
  payload: PostExtendPayload,
): Promise<PostResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/bonputih-ijiran/extend-aging`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const checkIsRedReceiptAvailable = async (
  trxIdRedReceipt: string,
): Promise<PostResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/bonputih-ijiran/${trxIdRedReceipt}/validate`,
    method: "GET",
  });

  return data;
};

interface PostVerifyTransferPayload {
  trx_id: string,
  file_name: string,
  file_base64: string,
  file_size: string,
  transfer_date: string,
}

export const postVerifyTransfer = async (
  payload: PostVerifyTransferPayload,
): Promise<PostResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/closebon/upload/receipt-transfer`,
    method: "POST",
    data: payload,
  });

  return data;
};

export interface GetTrxRedReceiptHistoryPayloadI {
  search?: string,
  area_id?: string,
  pool_id?: string,
  segment?: string,
  start_date?: string,
  end_date?: string,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface IGetTrxRedReceiptHistoryResponse {
  list_trx_closebon_history: GetTrxRedReceiptParamsI[],
  metadata: MetadataI
}

export const getTrxRedReceiptHistory = async (
  payload: GetTrxRedReceiptHistoryPayloadI,
): Promise<IGetTrxRedReceiptHistoryResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/history/closebon`,
    method: "GET",
    params: payload,
  });

  return data;
};
